import { Card, CheckIcon, Header, Label } from './styles'

/**
 * 시군구 isFullCoverage=true 일 때 사용하는 정적 카드 (경기 한정).
 *
 * 펼침 없음. 체크 마크 + "전 지역 수거 가능" 한 줄.
 * 적용 분기는 SiGunGuChildren 에서 처리.
 */
export default function FullCoverageCard() {
  return (
    <Card>
      <Header>
        <CheckIcon
          width={20}
          height={20}
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          aria-hidden='true'>
          <path
            d='M4 10.5 L8.5 15 L16 6.5'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </CheckIcon>
        <Label>전 지역 수거 가능</Label>
      </Header>
    </Card>
  )
}
